import queryString from 'query-string';

import { env, type Environment } from './environment';

// The base domain of DRYCUT (landing page)
const HomeUrls: Record<Environment, string> = {
  development: 'http://localhost:4001',
  production: 'https://www.drycut.ch',
  staging: 'https://staging--drycut-booking.netlify.app',
};

const ApiUrls: Record<Environment, string> = {
  development: 'http://localhost:3000',
  production: 'https://api.drycut.ch',
  staging: 'https://staging-api.drycut.ch',
};

const BookingUrls: Record<Environment, string> = {
  development: 'http://localhost:4001', // same url as home but can be a different app running
  production: 'https://booking.drycut.ch',
  staging: 'https://staging--drycut-booking.netlify.app',
};

const CheckoutUrls: Record<Environment, string> = {
  development: 'http://localhost:4001/checkout',
  production: 'https://booking.drycut.ch/checkout',
  staging: 'https://staging--drycut-booking.netlify.app/checkout',
};

const ReferralUrls: Record<Environment, string> = {
  development: 'http://localhost:3501', // same url as home but can be a different app running
  production: 'https://rf.drycut.ch',
  staging: 'https://staging-rf.drycut.ch',
};

const GraphApiSocketUris: Record<Environment, string> = {
  development: 'ws://localhost:3000/cable',
  production: 'wss://api.drycut.ch/cable',
  staging: 'wss://staging-api.drycut.ch/cable',
};

const TermsAndConditionsUrl = `${HomeUrls['production']}/terms-and-conditions`;

const CutNowURL = (coupon: null | string = null) => {
  const href = queryString.stringifyUrl({
    url: Navigation.HOME_URL,
    query: { coupon: coupon ?? undefined },
    fragmentIdentifier: 'stores-section',
  });

  return href;
};

export function CheckoutUrl(storeSlug?: string): string {
  const base = Navigation.CHECKOUT_URL;
  return `${base}/${storeSlug}`;
}

// This is the main object that can be used by all the apps and libraries to get the URLs of the
// whole system.
export const Navigation = {
  BASE_URL: import.meta.env.BASE_URL, // determined by the base config option
  HOME_URL: HomeUrls[env],
  API_URL: ApiUrls[env],
  ADMIN_API_URL: `${ApiUrls[env]}/admin`,
  GRAPH_API_URL: `${ApiUrls[env]}/graphql`,
  GRAPH_API_WS_URI: GraphApiSocketUris[env],
  CUT_NOW_URL: CutNowURL,
  BOOKING_URL: BookingUrls[env],
  REFERRAL_URL: ReferralUrls[env],
  CHECKOUT_URL: CheckoutUrls[env],
  TERMS_AND_CONDITIONS: TermsAndConditionsUrl,
};
